<template>
  <main>
    <component
      ref="current"
      :is="currentComponent"
      :pengembalian="item"
      @view="changeComponent"
    />
  </main>
</template>
<script>
import ListPengembalian from "./ListPengembalian.vue";
import DetailPengembalian from "./DetailPengembalian.vue";

export default {
  components: {
    ListPengembalian,
    DetailPengembalian,
  },
  data() {
    return {
      currentComponent: "ListPengembalian",
      item: {},
    };
  },
  methods: {
    changeComponent({ component, pengembalian }) {
      this.item = pengembalian;
      this.currentComponent = component;
    },
    refresh() {
      this.currentComponent = "ListPengembalian";
      this.$nextTick(() => {
        const child = this.$refs.current;
        if (child && typeof child.getReturData === "function") {
          child.getReturData();
        }
      });
    },
  },
};
</script>
